import { Trans } from '@fec/assets/js/utils/trans.js';

const sInMs = 1000; // 1 (s)econd is 1000 in (m)illi(s)econds
const mInMs = sInMs * 60; // 1 (m)inute is 1000 * 60 in ms
const hInMs = mInMs * 60; // 1 (h)our is 1000 * 60 * 60 in ms
const dInMs = hInMs * 24; // 1 (d)ay is 1000 * 60 * 60 * 24 in ms

export const init = () => {
  const trans = new Trans();

  Array.from(document.querySelectorAll('.js-event-countdown')).forEach(
    (element) => {
      let state = getInitialState(element, trans);

      const setCountdown = () => {
        // update the state with the current time left, correct days/hours/minutes/seconds, etc.
        state = updateState(state);

        // populate DOM-elements with the number of days/hours/minutes/seconds left AND improve UX by switching plural and singular label
        render(state);
      };

      // start the whole thing - immediately and then in 1 second intervals
      setCountdown();
      setInterval(() => setCountdown(), 1000);
    },
  );
};

const getInitialState = (element, trans) => {
  return {
    d: {
      value: 0,
      numberElement: element.querySelector('.js-event-countdown-day-block b'),
      textElement: element.querySelector('.js-event-countdown-day-block i'),
      number: '',
      text: '-',
    },
    h: {
      value: 0,
      numberElement: element.querySelector('.js-event-countdown-hour-block b'),
      textElement: element.querySelector('.js-event-countdown-hour-block i'),
      number: '',
      text: '-',
    },
    m: {
      value: 0,
      numberElement: element.querySelector(
        '.js-event-countdown-minute-block b',
      ),
      textElement: element.querySelector('.js-event-countdown-minute-block i'),
      number: '',
      text: '-',
    },
    s: {
      value: 0,
      numberElement: element.querySelector(
        '.js-event-countdown-second-block b',
      ),
      textElement: element.querySelector('.js-event-countdown-second-block i'),
      number: '',
      text: '-',
    },
    element: element,
    eventTS: new Date(element.dataset.datetime),
    isInTheFuture: false,
    a11yTextElem: element.querySelector(
      '.js-event-countdown-offscreen-counter',
    ),
    texts: trans.getAll(element),
  };
};

const updateState = (state) => {
  const nowTS = new Date(); // get the timestamp of NOW
  const diffTS = Math.abs(state.eventTS - nowTS); // subtract now from the event timestamp

  let d = Math.floor(diffTS / dInMs); // how many days left?
  state.d.value = d;
  state.d.number = `${d}`.padStart(2, '0');
  state.d.text = d === 1 ? state.texts.day : state.texts.days;

  let h = Math.floor((diffTS % dInMs) / hInMs); // how many hours left?
  state.h.value = h;
  state.h.number = `${h}`.padStart(2, '0');
  state.h.text = h === 1 ? state.texts.hour : state.texts.hours;

  let m = Math.floor((diffTS % hInMs) / mInMs); // how many minutes left?
  state.m.value = m;
  state.m.number = `${m}`.padStart(2, '0');
  state.m.text = m === 1 ? state.texts.minute : state.texts.minutes;

  let s = Math.floor((diffTS % mInMs) / sInMs); // how many seconds left?
  state.s.value = s;
  state.s.number = `${s}`.padStart(2, '0');
  state.s.text = s === 1 ? state.texts.second : state.texts.seconds;

  state.isInTheFuture = state.eventTS > nowTS;

  return state;
};

const render = (state) => {
  // write out the countdown numbers into the corresponding DOM elements
  ['d', 'h', 'm', 's'].forEach((unit) => {
    state[unit].numberElement.innerText = state[unit].number;
    state[unit].textElement.innerText = state[unit].text;
  });

  // write out the countdown in a11y text for screen readers, so not every number is read out separately
  state.a11yTextElem.innerText = `${state.d.number} ${state.d.text}, ${state.h.number} ${state.h.text}, ${state.m.number} ${state.m.text}, ${state.s.number} ${state.s.text}`;

  // counting down vs. counting up looks slightly different
  state.element.classList.toggle('event-countdown--past', !state.isInTheFuture);

  // for very far away events, squish the day's numbers a bit closer together
  state.element.classList.toggle(
    'event-countdown--far-away',
    state.d.value > 99,
  );
};
